var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLineNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 17.0003 17.611",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.16684 13.2776H11.8335M7.68158 1.41429L2.02966 5.81023C1.65185 6.10408 1.46295 6.25101 1.32686 6.43501C1.20631 6.598 1.1165 6.78161 1.06186 6.97684C1.00017 7.19723 1.00017 7.43654 1.00017 7.91517V13.9443C1.00017 14.8777 1.00017 15.3444 1.18182 15.7009C1.34161 16.0145 1.59658 16.2695 1.91018 16.4293C2.2667 16.6109 2.73341 16.6109 3.66683 16.6109H13.3335C14.2669 16.6109 14.7336 16.6109 15.0902 16.4293C15.4038 16.2695 15.6587 16.0145 15.8185 15.7009C16.0002 15.3444 16.0002 14.8777 16.0002 13.9443V7.91517C16.0002 7.43654 16.0002 7.19723 15.9385 6.97684C15.8838 6.78161 15.794 6.598 15.6735 6.43501C15.5374 6.25101 15.3485 6.10408 14.9707 5.81023L9.31876 1.41429C9.02598 1.18658 8.8796 1.07273 8.71796 1.02896C8.57533 0.990346 8.425 0.990346 8.28238 1.02896C8.12074 1.07273 7.97435 1.18658 7.68158 1.41429Z",
    stroke: "#000000",
    strokeWidth: 1.47,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLineNew);
export default __webpack_public_path__ + "static/media/home-line-new.55ea28345b3d8f449c45015dca58bf52.svg";
export { ForwardRef as ReactComponent };